<template>
    <ResourceList addLabel="Add"
                  :addRoute="!hideAddButton ? addRoute : null"
                  :params="params"
                  :query="query"
                  ref="resourceList"
                  :resource="resource"
                  :renderAs="renderAs"
                  title="Movements"
    />
</template>

<script>
import {Movement} from '@/internal';
import MovementResourceListItem from '@/components/Movement/ResourceListItem.vue';

export default {
  name: 'MovementResourceList',
  data() {
    return {
      params: {
        include: [],
      },
      resource: Movement,
    };
  },
  props: {
    addRoute: {
      default() {
        return window.app.findRouteByName('movement/create');
      },
      required: false,
    },
    hideAddButton: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => {
      },
      required: false,
    },
    renderAs: {
      default: () => {
        return MovementResourceListItem;
      },
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
